<template>
    <div class="business-info">
        <v-row class="mx-0 pt-8" v-if="isSeller">
            <v-col cols="12">
                <h2>Товары</h2>
            </v-col>
            <v-col cols="12">
                <v-row class="mx-0">
                    <v-col cols="12">
                        Всего товаров: <strong class="teal--text">{{ baseUserData.products.total }}</strong>
                    </v-col>
                    <v-col cols="12">
                        Скрыто товаров: <strong class="teal--text">{{ baseUserData.products.hidden }}</strong>
                    </v-col>
                    <v-col cols="12">
                        Нет в наличии: <strong class="teal--text">{{ baseUserData.products.notExists }}</strong>
                    </v-col>
                    <v-col cols="12">
                        <v-list dense>
                            <v-list-item v-for="category in baseUserData.products.categories" :key="category.id">
                                <div>{{ category.categoryName }}: <strong class="teal--text">{{ category.count }}</strong></div>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="mx-0 pt-8">
            <v-col cols="12">
                <h2>Сделки</h2>
            </v-col>
            <v-col cols="12">
                <v-row class="mx-0">
                    <v-col cols="12">
                        Всего сделок: <strong class="teal--text">{{ baseUserData.orders.total }}</strong>
                    </v-col>
                    <v-col cols="12">
                        Сумма: <strong class="teal--text">{{ baseUserData.orders.sum }} UAH</strong>
                    </v-col>
                    <!--<v-col cols="12">
                        Скидка: <strong class="teal&#45;&#45;text">{{ baseUserData.orders.discount }} %</strong>
                    </v-col>-->
                    <v-col cols="12">
                        Сумма с учетом коммерческой политики: <strong class="teal--text">{{ baseUserData.orders.sumWithDiscount }} UAH</strong>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="mx-0 pt-8" v-if="isSeller">
            <v-col cols="12">
                <h2>Договора</h2>
            </v-col>
            <v-col cols="12">
                <span class="pr-8" v-for="contract in baseUserData.contracts" :key="contract.id">
                    <a :href="contract.link"  target="_blank">
                    {{ contract.name }}
                </a>
                </span>
            </v-col>
        </v-row>
        <div class="spacer"></div>
        <div class="spacer"></div>
        <div class="spacer"></div>
        <div class="text-center">
            <v-btn text color="orange" :to="userProducts" class="mr-8" v-if="isSeller">Перейти к продуктам</v-btn>
            <v-btn text color="orange" :to="userOrders" class="mr-8">Перейти к сделкам</v-btn>
        </div>
    </div>
</template>

<script>
    import UserDataMixin from "./UserDataMixin"

    export default {
        name: "BusinessInfo",
        props:['user', 'isSeller'],
        mixins: [UserDataMixin],
        computed: {
            userProducts() {
                return '/products/?seller=' + this.user;
            },
            userOrders() {
                return '/orders/?seller=' + this.user;
            }
        }
    }
</script>

<style scoped>

</style>